import React, {
  FunctionComponent, useEffect, useRef, useState,
} from 'react';
import {
  Box, Flex, Text, BoxProps,
} from 'rebass/styled-components';
import styled from 'styled-components';
import {
  dateTimeFormatter,
  ExecutionCardProps,
  NextActionExecutionList,
  PolicyExecution,
  PolicyExecutionTableHeaders,
} from '.';
import {
  HorizontalRule, Card, CardHeader, CollapsibleDrawerArrow,
} from '..';

interface IStyledIcon extends BoxProps {
  isOpen?: boolean,
}

const StyledIcon = styled(Box)<IStyledIcon>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transform: rotate(${({ isOpen }: IStyledIcon) => (isOpen ? '0' : '-90deg')});
`;

const NextActionSummaryCard: FunctionComponent<
ExecutionCardProps
> = ({ execution, isDrawerOpen = false }: ExecutionCardProps) => {
  // timestamp is string when serialized on front end
  const dtStr = dateTimeFormatter(execution.timestamp as unknown as string);
  const [isOpen, setOpen] = useState<boolean>(isDrawerOpen);
  const isMounted = useRef<boolean>(false);

  const handleClick = () => {
    if (isMounted.current) {
      setOpen((prev: boolean) => !prev);
    }
  };

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <Card
      key={execution.executionId}
      data-testid="execution-card"
      mt={4}
      mr={3}
    >
      <Flex flexDirection="column">
        <CardHeader
          display="flex"
          justifyContent="space-between"
          height={54}
          alignItems="center"
          onClick={handleClick}
          data-testid="execution-card-header"
        >
          <Flex>
            <Text variant="p2" mr={2}>Conversation ID:</Text>
            <Text variant="p3" data-testid="text-conversation-id">{execution.context.conversationId}</Text>
          </Flex>
          <Text variant="p3" data-testid="execution-card-datetime">{dtStr}</Text>
          <Box color="primary">
            <CollapsibleDrawerArrow isOpen={isOpen} />
          </Box>
        </CardHeader>

        {isOpen && (
          <>
            <HorizontalRule />
            <Box pt={4} pr={0} pb={4} pl={4}>
              <Box py={3}>
                <PolicyExecutionTableHeaders />
              </Box>
              {execution?.history && (
                <NextActionExecutionList list={execution?.history} execution={execution} />
              )}
            </Box>
          </>
        )}
      </Flex>
    </Card>
  );
};

export default NextActionSummaryCard;
